import { render, staticRenderFns } from "./VoucherCode.vue?vue&type=template&id=5540e0dd&scoped=true"
import script from "./VoucherCode.vue?vue&type=script&lang=js"
export * from "./VoucherCode.vue?vue&type=script&lang=js"
import style0 from "./VoucherCode.vue?vue&type=style&index=0&id=5540e0dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5540e0dd",
  null
  
)

export default component.exports